import { Component, EventEmitter, Inject, Input, NgModuleRef, Output } from '@angular/core';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { ProfileResponse } from './profile.response';
import { RbacPermissionsConstant } from '../../../../../core/services/rbac/rbac-permissions.constant';
import { InfoModal } from '../../../../../core/modals/info/info.modal';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { OFFER_PRIVACY_TRANSLATIONS } from '../../../../../core/services/data/data-constants-translations';

@Component({
  selector: 'gtd-widget-offers-profile',
  templateUrl: './profile.component.html',
})
export class OfferProfileComponent extends GtdNgWidgetComponentAbstract {
  public data: ProfileResponse = new ProfileResponse();
  @Input() id: number;
  @Input() customClass: string;
  protected readonly key: string = 'Offer\\Profile';
  RbacPermissionsConstant = RbacPermissionsConstant;
  offer_privacy_translations = {
    Public: OFFER_PRIVACY_TRANSLATIONS[0],
    Private: OFFER_PRIVACY_TRANSLATIONS[1],
    'Request Only': OFFER_PRIVACY_TRANSLATIONS[2],
  };
  @Output() offerLoaded = new EventEmitter<ProfileResponse>();
  constructor(@Inject(IMODALS_SERVICE) protected modalsService: IModalsService, private ngModuleRef: NgModuleRef<any>) {
    super();
  }

  public openDescriptionModal(): void {
    this.modalsService.open(
      InfoModal,
      {
        data: {
          title: $localize`:@@common:Description`,
          subTitle: '',
          body: this.data.description_preset_id ? this.data.description_preset_description : this.data.description,
          footerType: null,
          hasCopy: false,
          class: '-info',
        },
      },
      this.ngModuleRef
    );
  }

  public afterData() {
    this.offerLoaded.emit(this.data);
  }
}
